<template>
  <div>
    <div
      class="alert alert-danger"
      :class="[`mb-${index + 1 === errors.length ? '0': '2'}`]"
      v-for="(error, index) in errors"
      :key="error"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormErrors',
  props: {
    errors: {
      required: true,
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
